import {UIElement} from "./ui";
import {stripTags, validateEmail} from "../util";
import '/modules/common/css/ui/contact.css';
import '/modules/common/css/ui/contact.responsive.css';
import '/modules/common/css/ui/contact.mobile.css';
import {Loader} from "./Loader";

const MIN_FILL_TIME_MS = 1.5 * 1000;

class ContactForm extends UIElement {

    constructor(postUrl, onChangeRuntimeConfig) {
        super('contact_form', onChangeRuntimeConfig);
        this.postUrl = postUrl;
    }

    getClassName(){
        return "ContactForm";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<div id="' + this.id + '" class="contact-form-container">' +
                '   <form>' +
                '       <div class="email">' +
                '           <label>' + tumbo.translator.translate('contact.email') + '</label>' +
                '           <input type="email" maxlength="100"/>' +
                '           <div class="error"><ul></ul></div>' +
                '       </div>' +
                '       <div class="subject">' +
                '           <label>' + tumbo.translator.translate('contact.subject') + '</label>' +
                '           <input type="text" maxlength="100"/>' +
                '           <div class="error"><ul></ul></div>' +
                '       </div>' +
                '       <div class="message">' +
                '           <label>' + tumbo.translator.translate('contact.message') + '</label>' +
                '           <textarea maxlength="1000" rows="4"></textarea>' +
                '           <div class="error"><ul></ul></div>' +
                '       </div>' +
                '       <div class="submit">' +
                '           <button class="action submit" type="submit">' + tumbo.translator.translate('contact.submit') + '</button>' +
                '       </div>' +
                '       <div class="additional"><input type="text"/></div>' +
                '   </form>' +
                '</div>'
            );
            $('input, textarea', this.uiElement).keyup(() => {
                if (!this.fillStart)
                    this.fillStart = new Date();
                this._checkSubmitEnabled();
            });
            $('button.submit', this.uiElement).click((e) => {
                this.logStat("SEND_MESSAGE")
                this._submit();
                return true;
            });
            this._checkSubmitEnabled();
            this.loader = new Loader('contact_form_loader',this.uiElement);
        }
        return this.uiElement;
    }

    _checkSubmitEnabled() {
        if (!this.fillStart)
            $('button.submit', this.uiElement).addClass('disabled').attr('disabled', 'disabled');
        else $('button.submit', this.uiElement).removeClass('disabled').removeAttr('disabled');
    }

    _submit() {
        if (!this._validateSecurity()) {
            setTimeout(()=>{
                this.fillStart = new Date();
                this._checkSubmitEnabled();
            }, MIN_FILL_TIME_MS)
            return;
        }

        if (!this._validateFields())
            return;

        this.loader.show();
        $.post(
            this.postUrl,
            {
                data: JSON.stringify({
                    subject: this._getSubject(),
                    message: this._getMessage(),
                    email: this._getEmail()
                }),
            },
            (data, textStatus, jqXHR) => {
                if (textStatus.toLowerCase() !== 'success')
                    this.logError("Error sending message: " + textStatus)
                else {
                    alert(tumbo.translator.translate('contact.confirmation'));
                    this.fillStart = new Date();
                    this._clear();
                    this.logInfo("Message sent");
                }
                this.loader.hide();
            }
        ).fail((jqXHR, textStatus, errorThrown) => {
            alert(tumbo.translator.translate('contact.sendError'))
            this.logError("Could not send message: " + textStatus, errorThrown);
            this.fillStart = new Date();
            this._checkSubmitEnabled();
            this.loader.hide();
        });
    }

    _clear() {
        $('input, textarea', this.uiElement).val('');
        this.fillStart = undefined;
        this._checkSubmitEnabled();
    }

    _validateFields() {
        let error = false;
        $('.error ul', this.uiElement).empty();

        const email = this._getEmail();
        if (!email || email.length <= 0) {
            $('.email .error ul', this.uiElement).append('<li>' + tumbo.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        } else if (!validateEmail(email)) {
            $('.email .error ul', this.uiElement).append('<li>' + tumbo.translator.translate('contact.error.invalidEmail') + '</li>');
            error = true;
        }

        const subject = this._getSubject();
        if (!subject || subject.length <= 1) {
            $('.subject .error ul', this.uiElement).append('<li>' + tumbo.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        }

        const message = this._getMessage();
        if (!message || message.length <= 1) {
            $('.message .error ul', this.uiElement).append('<li>' + tumbo.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        }

        if (error)
            $('.error', this.uiElement).addClass('show');
        else $('.error', this.uiElement).removeClass('show');

        return !error;
    }

    _getMessage() {
        return stripTags($('.message textarea', this.uiElement).val()).trim();
    }

    _getSubject() {
        return stripTags($('.subject input', this.uiElement).val()).trim();
    }

    _getEmail() {
        return stripTags($('.email input', this.uiElement).val()).trim();
    }

    _validateSecurity() {
        const fillTimeMs = this.fillStart ? new Date() - this.fillStart : 0;
        this.fillStart = undefined;
        this._checkSubmitEnabled();

        if (fillTimeMs < MIN_FILL_TIME_MS)
            return false;

        if (!this.uiElement.is(':visible'))
            return false;

        const additionalVal = $('.additional input', this.uiElement).val();
        if (additionalVal && additionalVal.length > 0)
            return false; //honeypot

        return true;
    }
}

class ContactButton extends UIElement {
    constructor(modal, postUrl, onChangeRuntimeConfig) {
        super('contact_button', onChangeRuntimeConfig);
        this.modal = modal;
        this.form = new ContactForm(postUrl, onChangeRuntimeConfig);
    }

    getClassName(){
        return "ContactButton";
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<div id="' + this.id + '" class="contact-button-container">' +
                '   <button type="button" title="' + tumbo.translator.translate('contact.buttonName') + '"></button>' +
                '</div>'
            );

            this.modal.setTitle(tumbo.translator.translate('contact.formTitle'))
            this.modal.setContent(this.form.getUIElement());

            $('button', this.uiElement).click(() => {
                if (this.modal.isVisible()) {
                    this.modal.hide();
                } else this.modal.show();
            });
        }
        return this.uiElement;
    }
}

export {ContactButton}